import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import ReferralOptions from '../ReferralsIndexContainer/ReferralOptions';

function EmployerReferralModal({
  showModal,
  onHideCallback,
  csrfToken,
  referralPath,
  newReferralPath,
  shareOnLinkedinUrl,
  authCodeUrl,
  authStatus,
  referralHeroCopy,
}) {
  return (
    <Modal show={showModal} onHide={onHideCallback}>
      <Modal.Header closeButton />
      <Modal.Body>
        <ReferralOptions
          csrfToken={csrfToken}
          referralPath={referralPath}
          newReferralPath={newReferralPath}
          shareOnLinkedinUrl={shareOnLinkedinUrl}
          authCodeUrl={authCodeUrl}
          authStatus={authStatus}
          referredUserType="employer"
          heroCopy={referralHeroCopy}
          location="Employer Post-Hire"
          isConsultant={false}
          showSocialMediaShareButtons
        />
      </Modal.Body>
    </Modal>
  );
}

EmployerReferralModal.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  referralPath: PropTypes.string.isRequired,
  newReferralPath: PropTypes.string.isRequired,
  shareOnLinkedinUrl: PropTypes.string.isRequired,
  referralHeroCopy: PropTypes.string.isRequired,
  authCodeUrl: PropTypes.string,
  authStatus: PropTypes.number,
  showModal: PropTypes.bool.isRequired,
  onHideCallback: PropTypes.func.isRequired,
};

EmployerReferralModal.defaultProps = {
  authCodeUrl: null,
  authStatus: null,
};

export default EmployerReferralModal;
